import { Navigate, useParams } from "react-router-dom";
import Loader from "../components/Loader";
import ErrorMessage from "../components/ErrorMessage";
import { useStoreLabel } from "../hooks/useStore";

const LaunchStorePage = () => {
  const { storeLabel } = useParams();
  const { data, isLoading, isError, error } = useStoreLabel(storeLabel);

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <ErrorMessage
        errorMessage={error.message}
        style={{ minHeight: "53vh" }}
      />
    );
  }

  if (
    data?.accountId &&
    data?.accountType === "pro" &&
    data?.hasRetailStore &&
    data?.active
  ) {
    return <Navigate to="/" />;
  }

  return (
    <ErrorMessage
      errorMessage={"Retail Store was not found."}
      style={{ minHeight: "53vh" }}
    />
  );
};

export default LaunchStorePage;
